/* eslint-disable no-unused-vars */
<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="!isEdit?$t('system.menuManager.create'):$t('system.menuManager.update')"
      :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle style="padding-top:10px">
      <el-row type="flex" justify="start" >
        <el-col :span="12">
          <el-form :rules="rules" :model="formInfo" :label-position="'right'" ref="formLeft" :label-width="$t('system.menuManager.leftLabelWidth')">
            <el-form-item :label=" $t('system.menuManager.parentMenu') + '：'">
              <el-input v-model="formInfo.parentMenu" disabled />
            </el-form-item>
            <!-- <el-form-item :label="'菜单名称：'" prop="functionName">
              <el-input v-model="formInfo.functionName" :maxlength="50" clearable :placeholder="$t('system.menuManager.menuName')" />
            </el-form-item> -->
            <el-form-item :label="$t('system.menuManager.menuName') +'：'" prop="functionName">
              <el-input v-model="formInfo.functionName" :maxlength="50" clearable :placeholder="$t('system.menuManager.menuName')" />
            </el-form-item>
            <el-form-item :label="$t('system.menuManager.sort') +'：'" prop="sort">
              <!-- <el-input v-model="formInfo.sort" clearable :placeholder="$t('system.menuManager.menuName')" /> -->
              <el-input-number v-model="formInfo.sort" :min="0" :max="10000" ></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('system.menuManager.icon') +'：'" prop="icon">
              <el-input v-model="formInfo.icon" :maxlength="20" clearable :placeholder="$t('system.menuManager.icon')" />
            </el-form-item>
            <el-form-item :label="$t('system.menuManager.weight') +'：'" prop="weight">
              <!-- <el-input v-model="formInfo.weight" clearable :placeholder="$t('system.menuManager.menuName')" /> -->
              <el-select
                  v-model="formInfo.weight"
                  filterable
                  clearable
                  :placeholder="$t('system.menuManager.weight')"               
                >
                  <el-option
                    v-for="(item,index) in menuWeightList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form :rules="rules" :model="formInfo" ref="formRight" :label-position="'right'" :label-width="$t('system.menuManager.rightLabelWidth')">
            <el-form-item :label=" $t('system.menuManager.menuType')+'：'" required prop="functionType">
              <!-- <el-input v-model="formInfo.functionType" clearable :placeholder="$t('system.menuManager.menuName')" /> -->
              <el-radio-group v-model="formInfo.functionType">
                <el-radio :label="1">
                  {{$t('system.menuManager.menu')}}
                </el-radio>
                <el-radio :label="2">
                  {{$t('system.menuManager.button')}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label=" $t('system.menuManager.menuNameEn') +'：'" prop="functionNameEn">
              <el-input v-model="formInfo.functionNameEn" :maxlength="50" clearable :placeholder="$t('system.menuManager.menuNameEn')" />
            </el-form-item>
            <el-form-item :label="$t('system.menuManager.link')+'：'" prop="url">
              <el-input v-model="formInfo.url" :max="100" clearable :placeholder="$t('system.menuManager.link')" />
            </el-form-item>
            <el-form-item :label="$t('system.menuManager.isShow')+'：'" required  prop="isShow">
              <!-- <el-input v-model="formInfo.isShow" clearable :placeholder="$t('system.menuManager.menuName')" /> -->
              <el-radio-group v-model="formInfo.isShow">
                <el-radio :label="0">
                  {{$t('system.menuManager.hide')}}
                </el-radio>
                <el-radio :label="1">
                  {{$t('system.menuManager.show')}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('system.menuManager.permission')+'：'" prop="permission">
              <el-input v-model="formInfo.permission" :maxlength="200" clearable :placeholder="$t('system.menuManager.permission')" />
              
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-form :model="formInfo" :label-width="$t('system.menuManager.rightLabelWidth')">
        <el-form-item :label="$t('system.menuManager.otherWeight') +'：'" prop="weight">
          <el-select
            v-model="formInfo.otherWeightArr"
            multiple
            clearable
            :placeholder="$t('system.menuManager.otherWeight')"               
            >
            <el-option
              v-for="(item,index) in menuWeightList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="start" align="middle">
        <el-col :span="24">
          <el-form ref="form1" :rules="rules" :model="formInfo" :label-position="'right'" :label-width="$t('system.menuManager.leftLabelWidth')">
            <el-form-item :label="$t('public.note')+ '：'">
              <el-input
                v-model="formInfo.remark"
                :rows="6"
                :maxlength="500"
                :autosize="{ minRows: 3, maxRows: 3}"
                resize="none"
                :placeholder="$t('public.note')"
                type="textarea"
              />
            </el-form-item>
          </el-form>
        </el-col>
    </el-row>
  </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="headleCancel">{{$t('public.cancel')}}</el-button>
      <el-button type="primary" @click="submitForm">{{$t('public.define')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { createMenu, updateMenu } from '@/api/system/menuManager'
import { partialForm } from '@/mixins/partialForm'
// 辅助函数
// import { mapGetters } from 'vuex'
export default {
  name: 'MenuAddUpdateDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const functionName = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.menuManager.msg.error1')))
      }
    }
    const sort = (rule, value, cb) => {
      if (!value) {
         return cb(new Error(this.$t('system.menuManager.msg.error2')))
      }
    }
    const functionNameEn = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.menuManager.msg.error3')))
      }
    }
    const weight = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.menuManager.msg.error4')))
      }

    }
    return {
      defaultFormInfo: {
        functionType: 1,
        isShow: 1,
        sort: 1,
        otherWeightArr: []
      },
      formInfo: {},
      menuWeightList: [
        { label: this.$t('system.menuManager.weightList.list1'), value: 100 },
        { label: this.$t('system.menuManager.weightList.list2'), value: 200 },
        { label: this.$t('system.menuManager.weightList.list3'), value: 300 },
        { label: this.$t('system.menuManager.weightList.list4'), value: 400 },
        { label: this.$t('system.menuManager.weightList.list5'), value: 500 },
        { label: this.$t('system.menuManager.weightList.list6'), value: 600 }
      ],
      rules: {
        functionName: [
          { required: true, trigger: ['blur','change'], validator: functionName }
        ],
        sort: [
          { required: true, trigger: ['blur','change'], validator: sort },
        ],
        functionNameEn: [
          { required: true, trigger: ['blur','change'], validator: functionNameEn }
        ],
        weight: [
          { required: true, trigger: ['blur','change'], validator: weight }
        ]
      }
    }
  },
  watch: {
    visibles: {
      handler(e1) {
        if(e1){
          this.formInfo = { ...this.defaultFormInfo, ...this.data }
          const otherWeight = this.data.otherWeight
          if (otherWeight) {
            this.formInfo.otherWeightArr = otherWeight.split(',').map(w => +w)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    restData(){
      this.formInfo = {...this.defaultFormInfo}
    },
    // 关闭dialog
    closeDialog() {
      this.restData()
      this.$emit('update:visibles', false)
    },
    // 点击取消
    headleCancel() {
      this.closeDialog()
    },
    // 点击确定按钮处理编辑和新增
    submitForm() {
      let checkLeft,checkRight
      checkLeft = this.checkForm({ formName: 'formLeft',
          formList: ['sort','functionName','weight'] })
        checkRight = this.checkForm({ formName: 'formRight',
          formList: ['functionNameEn'] })
      if(!checkLeft || !checkRight){
        return
      }
      // eslint-disable-next-line no-unused-vars
      const { parentMenu, functionId, otherWeightArr, ...postData } = this.formInfo
      if (otherWeightArr.length) {
        postData.otherWeight = otherWeightArr.join(',')
      } else {
        postData.otherWeight = ''
      }
      if (!this.isEdit) {
        this._addMenu(postData)
      } else {
        this._updateMenu({id: functionId,data: postData})
      }
    },
    // 新增
    _addMenu(postData) {
      createMenu(postData).then(({ data }) => {
        if (data.code === 0) {
          postData.functionId = data.data
          this.$emit('add-complete', {...postData})
          this.closeDialog()
        }
      })
    },
    // 更新
    _updateMenu(postData) {
      updateMenu(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('update-complete', { ...{functionId: postData.id},...postData.data })
          this.closeDialog()
        }
      })
    }
  }
}
</script>
